import React from "react";
import AppState from "../../../state";
import { Utils } from "../../../services";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableFooter,
  Typography,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Checkbox,
  FormControlLabel,
  TableSortLabel
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';

class RelatorioPassivoTrabalhista extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dt_calculo: null,
      projetos: [],
      relatorio: [],
      total_projetos: 0,
      isLoading: false,
      modalOpen: false,
      modalProject: null,
      statusProjeto: "andamento",
      mostrarEconomico: false, // Começa desmarcado (Financeiro)
      orderBy: 'id_projeto',
      order: 'asc'
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      AppState.isLoading = true;
      const res = await fetch(`${AppState.serverAddr}/relatorios/PassivoTrabalhista.php`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization: AppState.token
        }
      });

      if (res.status === 401) {
        AppState.isLoading = false;
        return;
      }

      const json = await res.json();
      AppState.isLoading = false;

      if (json && json.data) {
        const full = json.data.projetos || [];
        this.setState(
          {
            dt_calculo: json.data.dt_calculo,
            projetos: full,
            total_projetos: json.data.total_projetos || full.length
          },
          () => {
            this.filtroRelatorio();
          }
        );
      }
    } catch (err) {
      AppState.isLoading = false;
      console.error("Erro ao carregar Passivo Trabalhista", err);
    }
  };

  // Lógica simplificada e para trocar o estado
  toggleEconomico = () => {
    this.setState(prev => ({ mostrarEconomico: !prev.mostrarEconomico }));
  };

  handleSort = (property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    this.setState({
      order: isAsc ? "desc" : "asc",
      orderBy: property
    });
  };

  getSortedData = () => {
    const { relatorio, order, orderBy } = this.state;

    return [...relatorio].sort((a, b) => {
      let valueA, valueB;

      if (orderBy === "id_projeto") {
        valueA = a.projeto?.id_projeto || 0;
        valueB = b.projeto?.id_projeto || 0;
      } else if (orderBy === "desc_curta") {
        valueA = (a.projeto?.desc_curta || "").toLowerCase();
        valueB = (b.projeto?.desc_curta || "").toLowerCase();
      } else if (orderBy === "dt_inicio") {
        valueA = a.projeto?.dt_inicio ? new Date(a.projeto.dt_inicio).getTime() : 0;
        valueB = b.projeto?.dt_inicio ? new Date(b.projeto.dt_inicio).getTime() : 0;
      } else if (orderBy === "passivo_trabalhista") {
        valueA = parseFloat(a.resumo?.passivo_trabalhista) || 0;
        valueB = parseFloat(b.resumo?.passivo_trabalhista) || 0;
      } else if (orderBy === "df") {
        valueA = a.projeto?.id_projeto !== 0 ? (parseFloat(a.resumo?.df) || 0) : -1;
        valueB = b.projeto?.id_projeto !== 0 ? (parseFloat(b.resumo?.df) || 0) : -1;
      }

      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  renderResumoRow = projeto => {
    const resumo = projeto.resumo || {};
    const p = projeto.projeto || {};

    const passivo = resumo.passivo_trabalhista || 0;
    const df = (resumo.df != null && p.id_projeto !== 0) ? resumo.df : null;

    return (
      <TableRow key={p.id_projeto}>
        <TableCell>{p.id_projeto}</TableCell>
        <TableCell>{p.desc_curta}</TableCell>
        <TableCell>{this.formatDate(p.dt_inicio)}</TableCell>
        <TableCell>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 4 }}>
            <IconButton size="small" aria-label={`detalhar-passivo-${p.id_projeto}`} title="Detalhar" onClick={() => this.openModal(projeto)}>
              <AddIcon fontSize="small" />
            </IconButton>
            <span>{`R$ ${Utils.float2moeda(passivo)}`}</span>
          </div>
        </TableCell>
        <TableCell>{df != null ? `R$ ${Utils.float2moeda(df)}` : '-'}</TableCell>
      </TableRow>
    );
  };

  openModal = (projeto) => {
    this.setState({ modalOpen: true, modalProject: projeto });
  }

  closeModal = () => {
    this.setState({ modalOpen: false, modalProject: null });
  }

  filterHandleChange = name => event => {
    this.setState({ [name]: event.target.value }, () => {
      this.filtroRelatorio();
    });
  };

  filtroRelatorio = () => {
    const state = this.state;

    function filtraRelatorio(item) {
      const projeto = item.projeto || {};
      let status = state.statusProjeto;

      if (status === "andamento") status = "Ativo";
      else if (status === "encerrado") status = "Encerrado";

      if (status !== "todos") {
        return projeto.status === status;
      }
      return true;
    }

    if (this.state.projetos) {
      this.setState({ relatorio: this.state.projetos.filter(filtraRelatorio) });
    }
  };


  formatDate(iso) {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const AAAA = d.getFullYear();
    return `${dd}/${mm}/${AAAA}`;
  }

  computePrazo(contas) {
    const longCodes = ["2.1.4.9", "2.1.4.12", "2.1.4.10"];

    let totalLongo = 0;
    let totalCurto = 0;

    (contas || []).forEach(c => {
      const code = (c.id_conta || "").toString();
      const val = parseFloat(c.passivo_trabalhista) || 0;
      const isLong = longCodes.some(prefix => code.startsWith(prefix));
      if (isLong) {
        totalLongo += val;
      } else {
        totalCurto += val;
      }
    });

    return { totalLongo, totalCurto };
  }

  renderModalPrazoTables() {
    const contas = (this.state.modalProject && this.state.modalProject.detalhamento && this.state.modalProject.detalhamento.pessoal) || [];

    const { totalLongo, totalCurto } = this.computePrazo(contas);

    return (
      <div style={{ padding: 8}}>
        <Typography variant="subtitle1">Resumo de Prazo</Typography>
        <div style={{ display: 'flex', gap: 24, marginTop: 8 }}>
          <div>
            <Typography variant="caption">Longo Prazo</Typography>
            <div style={{ fontWeight: 700, marginTop: 4 }}>{`R$ ${Utils.float2moeda(totalLongo || 0)}`}</div>
          </div>
          <div>
            <Typography variant="caption">Curto Prazo</Typography>
            <div style={{ fontWeight: 700, marginTop: 4 }}>{`R$ ${Utils.float2moeda(totalCurto || 0)}`}</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { orderBy, order } = this.state;
    const sortedRelatorio = this.getSortedData();

    const { mostrarEconomico } = this.state;
    const headCellStyle = {
      fontSize: 15,
      fontWeight: 700,
      paddingTop: 18,
      paddingBottom: 18,
      position: 'sticky',
      top: 0,
      backgroundColor: '#fff',
      zIndex: 10
    };

    return (
      <Grid style={{ marginTop: "2em" }}>
        <Grid container spacing={16}>
          <Grid item xs={8}>
            <Typography variant="h5">Relatório - Passivo + DF</Typography>
            <Typography variant="body2" color="textSecondary">Data cálculo: {this.state.dt_calculo || "-"}</Typography>
            <Typography variant="caption" style={{ marginTop: 6, display: 'block' }}>{`Mostrando ${this.state.relatorio.length} de ${this.state.total_projetos}`}</Typography>
          </Grid>

          <Grid item xs={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '15px' }}>
            <FormControl style={{ minWidth: 200 }}>
              <InputLabel>Status do Projeto</InputLabel>
              <Select value={this.state.statusProjeto} onChange={this.filterHandleChange("statusProjeto")}>
                <MenuItem key={1} value="andamento">Em Andamento</MenuItem>
                <MenuItem key={2} value="encerrado">Encerrados</MenuItem>
                <MenuItem key={0} value="todos">Todos</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Paper style={{ padding: 16 }}>
              <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
                <Table>
                <TableHead>
                  <TableRow>
                    
                    <TableCell style={headCellStyle}>
                      <TableSortLabel
                        active={orderBy === 'id_projeto'}
                        direction={orderBy === 'id_projeto' ? order : 'asc'}
                        onClick={() => this.handleSort('id_projeto')}
                      >
                        <Tooltip title="Identificador do projeto" placement="top"><span>ID</span></Tooltip>
                      </TableSortLabel>
                    </TableCell>

                    <TableCell style={headCellStyle}>
                      <TableSortLabel
                        active={orderBy === 'desc_curta'}
                        direction={orderBy === 'desc_curta' ? order : 'asc'}
                        onClick={() => this.handleSort('desc_curta')}
                      >
                      <Tooltip title="Nome curto do projeto" placement="top"><span>Projeto</span></Tooltip>
                      </TableSortLabel>
                    </TableCell>

                    <TableCell style={headCellStyle}>
                      <TableSortLabel
                        active={orderBy === 'dt_inicio'}
                        direction={orderBy === 'dt_inicio' ? order : 'asc'}
                        onClick={() => this.handleSort('dt_inicio')}
                      >
                      <Tooltip title="Data de início do projeto" placement="top"><span>Início</span></Tooltip>
                      </TableSortLabel>
                    </TableCell>

                    <TableCell style={headCellStyle}>
                      <TableSortLabel
                        active={orderBy === 'passivo_trabalhista'}
                        direction={orderBy === 'passivo_trabalhista' ? order : 'asc'}
                        onClick={() => this.handleSort('passivo_trabalhista')}
                      >
                      <Tooltip title="Passivo trabalhista acumulado" placement="top"><span>Passivo Trabalhista</span></Tooltip>
                      </TableSortLabel>
                    </TableCell>

                    <TableCell style={headCellStyle}>
                      <TableSortLabel
                        active={orderBy === 'df'}
                        direction={orderBy === 'df' ? order : 'asc'}
                        onClick={() => this.handleSort('df')}
                      >
                        <Tooltip title="Despesa financeira acumulada até o último dia do mês anterior" placement="top"><span>DF</span></Tooltip>
                      </TableSortLabel>
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedRelatorio.map(p => this.renderResumoRow(p))}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 700 }}>
                    <TableCell colSpan={3} style={{ fontWeight: 700 }}>Total</TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '15px' }}>
                      {`R$ ${Utils.float2moeda(this.state.relatorio.reduce((total, item) => {return total + (parseFloat(item?.resumo?.passivo_trabalhista) || 0)}, 0))}`}
                    </TableCell>
                    <TableCell style={{ fontWeight: 700, fontSize: '15px' }}>
                      {`R$ ${Utils.float2moeda(
                        this.state.relatorio.reduce((total, item) => {
                          const p = item.projeto || {};
                          const dfVal = (item?.resumo?.df != null && p.id_projeto !== 0) ? item.resumo.df : 0;
                          return total + (parseFloat(dfVal) || 0);
                        }, 0)
                      )}`}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>

        {this.state.modalOpen && (
          <Dialog fullWidth maxWidth="md" open={this.state.modalOpen} onClose={this.closeModal}>
            <DialogTitle>
              {this.state.modalProject && `Detalhamento - Passivo Trabalhista - Projeto ${this.state.modalProject.projeto.id_projeto}`}
              <IconButton aria-label="close" style={{ position: 'absolute', right: 8, top: 8 }} onClick={this.closeModal}><CloseIcon/></IconButton>
            </DialogTitle>
            <DialogContent>
              {this.state.modalProject && this.renderModalPrazoTables()}
            </DialogContent>
          </Dialog>
        )}

      </Grid>
    );
  }
}

export default RelatorioPassivoTrabalhista;